<template>
    <div class="home">
        <carousel />
        <div class="run"></div>
        <!-- 關於 -->
        <div class="section about">
            <div class="auto">
                <h2 class="title">深森旅微笑旅行</h2>
                <p class="content">我們擁有著一份熱誠的心，並秉持服務至上的理念，使用合法車輛，並投保乘客險 我們有信心，我們的包車旅遊服務團隊，絕對會讓您擁有一趟愉快的旅程!</p>
                <router-link to="/order" class="btn">
                    <el-button round class="btn" type="success" plain>立即訂車</el-button>
                </router-link>
            </div>
        </div>
        <!-- 服務 -->
        <div class="section service">
            <div class="auto">
                <h2 class="title">服務 Service</h2>
                <div class="main">
                    <div class="item">
                        <div class="icon">
                            <i class="far fa-gem"></i>
                        </div>
                        <h3 class="subTitle">安全</h3>
                        <p class="content">司機都是領有良民證(無刑事記錄)與無肇事記錄的優良司機</p>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <i class="fas fa-heart"></i>
                        </div>
                        <h3 class="subTitle">安心</h3>
                        <p class="content">車輛都是三年內新車且定期進廠保養維修</p>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <i class="fas fa-check-square"></i>
                        </div>
                        <h3 class="subTitle">保障</h3>
                        <p class="content">每輛車均投保4000萬旅客險</p>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <i class="far fa-flag"></i>
                        </div>
                        <h3 class="subTitle">專業</h3>
                        <p class="content">司機都擁有專業駕駛能力，及旅遊知識</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 我們的服務 -->
        <div class="section ourservice">
            <div class="auto">
                <h2 class="title">我們的服務</h2>
                <p class="content">
                    接送服務，包車旅遊服務，結婚禮車，企業商務包車，婚紗寫真外拍包車，活動包車(露營，登山，自行車，溯溪，泛舟等戶外活動)
                    <br />您只要告訴我們人數、成員(大人、小孩)內容、行李數量與大小，就能按照行程內容，為您安排最適當、最省錢的車輛， 進行半日遊、一日遊、二日遊、多日遊、環島遊的不同行程活動。
                </p>
            </div>
        </div>
        <!-- 景點 -->
        <site />
        <div class="section">
            <div class="auto">
                <h2 class="text">和家人朋友，一起體會台灣之美吧!</h2>
                <router-link to="/order" class="btn">
                    <el-button type="success" round class="btn">立即訂車</el-button>
                </router-link>
            </div>
        </div>
        <!-- 聯絡我們 -->
        <div class="section contact">
            <div class="auto">
                <h2 class="title">聯絡我們 Contact us!</h2>
                <div class="content">
                    有任何問題都歡迎撥打客服專線，我們將竭誠的為您服務 客服時間:24hr
                </div>
                <div class="block">
                    <div class="icon">
                        <i class="el-icon-phone"></i>
                        0905-190571
                    </div>
                    <div class="icon">
                        <i class="el-icon-chat-line-round"></i>
                        LINE : samile333
                    </div>
                </div>
                <h2 class="title">歡迎使用粉絲專頁與我們聯繫</h2>
            </div>
        </div>
    </div>
</template>

<script>
import carousel from '@/components/carousel/index.vue';
import site from '@/components/site/index.vue';
export default {
    name: 'Home',
    components: {
        carousel,
        site
    }
};
</script>
<style lang="scss" scoped>
.home {
    font-family: '微軟正黑體', sans-serif;
    // 區塊
    .section {
        background-color: #222;
        padding: 48px 0;
        color: white;
        .auto {
            display: flex;
            flex-direction: column;
            width: 1440px;
            margin: auto;
            text-align: center;
            @media screen and (max-width: 1440px) {
                width: 1224px;
            }
            @media screen and (max-width: 1224px) {
                width: 96%;
            }
            .text {
                font-size: 30px;
                line-height: 40px;
                margin: 0 0 40px;
            }
            .btn {
                align-self: center;
                font-weight: 700;
            }
            .title {
                font-size: 30px;
                line-height: 40px;
                margin: 0 0 40px;
                position: relative;
                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    bottom: -20px;
                    width: 56px;
                    height: 4px;
                    background-color: white;
                }
            }
            .content {
                line-height: 24px;
                text-align: center;
                margin: 0 0 16px 0;
            }
        }
    }
    // 關於
    .about {
        background-color: $green;
        padding: 96px 0;
    }
    // 服務
    .service {
        background: white;
        padding: 96px 0;
        .auto {
            .title {
                color: $title;
                &:after {
                    background-color: $green;
                }
            }
            .main {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                color: $text;
                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin: 32px 24px 0;
                    width: 300px;
                    .icon {
                        i {
                            font-size: 56px;
                            color: $green;
                        }
                    }
                    .subTitle {
                        font-size: 24px;
                        margin: 16px 0;
                    }
                    .content {
                        line-height: 24px;
                    }
                }
            }
        }
    }
    // 我們的服務
    .ourservice {
        background-color: $deep-green;
    }
    // 聯絡我們
    .contact {
        background: white;
        .auto {
            color: $text;
            .title {
                color: $title;
                &:after {
                    background-color: $green;
                }
            }
            .block {
                display: flex;
                justify-content: center;
                .icon {
                    display: flex;
                    flex-direction: column;
                    margin: 8px 32px 24px;
                    i {
                        font-size: 40px;
                        margin: 0 0 16px;
                    }
                }
            }
        }
    }
}
</style>
